// extracted by mini-css-extract-plugin
module.exports = {"SliderNavigation":"styles_SliderNavigation__MMa84","item":"styles_item__qV7DN","dotSmall":"styles_dotSmall__tIkvF","dot":"styles_dot__yBb9h","active":"styles_active__yvJCH"};